//see https://m2.material.io/resources/color/#!/?view.left=1&view.right=1&primary.color=004B96&secondary.color=A8C7E6&primary.text.color=f2f2f2&secondary.text.color=111B2B
const palette = {
  alternate: {
    main: "#f2f2f2",
    dark: "#e8eaf6",
  },
  embarq: {
    neutral: {
      light: "#f2f2f2",
      dark: "#111b2b",
    },
    primary: {
      main: "#004b96",
      light: "#336FAB",
      dark: "#002467", // or 003469
      contrastText: "#f2f2f2",
    },
    secondary: {
      light: "#dafaff",
      main: "#a8c7e6",
      dark: "#7896b4",
      contrastText: "#111b2b",
    },
    accent: {
      light: "#ffcc5f",
      main: "#df9b2e",
      dark: "#a96d00",
      contrastText: "#111b2b",
    },
  },
  cardShadow: "rgba(23, 70, 161, .11)",
  common: {
    black: "#000",
    white: "#fff",
  },
  type: "light",
  primary: {
    main: "#004b96",
    light: "#336FAB",
    dark: "#002467",
    contrastText: "#f2f2f2",
  },
  secondary: {
    light: "#ffb74d",
    main: "#df9b2e",
    dark: "#f57c00",
    contrastText: "#111b2b",
  },
  error: {
    light: "#e57373",
    main: "#f44336",
    dark: "#d32f2f",
    contrastText: "#fff",
  },
  warning: {
    light: "#ffb74d",
    main: "#ff9800",
    dark: "#f57c00",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  info: {
    light: "#64b5f6",
    main: "#2196f3",
    dark: "#1976d2",
    contrastText: "#fff",
  },
  success: {
    light: "#81c784",
    main: "#4caf50",
    dark: "#388e3c",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  grey: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161",
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.54)",
    disabled: "rgba(0, 0, 0, 0.38)",
    hint: "rgba(0, 0, 0, 0.38)",
    white: "rgba(255,255,255,0.8)",
    light: "rgba(242,242,242,0.6)",
  },
  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: "#fff",
    default: "#fff",
    level2: "#f5f5f5",
    level1: "#fff",
    footer: "#1b1642",
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
};

export default palette;
